"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMiniButtonSlots = exports.default = exports.MiniButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _miniButtonClasses = _interopRequireWildcard(require("./miniButtonClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getMiniButtonSlots = ownerState => {
  const {
    color,
    disabled
  } = ownerState;
  return {
    root: ['root', 'text', `text${(0, _components.capitalize)(color)}`, disabled && 'disabled']
  };
};
exports.getMiniButtonSlots = getMiniButtonSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getMiniButtonSlots(ownerState);
  const composedClasses = (0, _mui.unstable_composeClasses)(slots, _miniButtonClasses.getMiniButtonUtilityClass, classes);
  return {
    ...classes,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...composedClasses
  };
};
const MiniButtonRoot = (0, _mui.styled)(_mui.ButtonBase, {
  name: 'MiniButton',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, styles.text, styles[`text${(0, _components.capitalize)(ownerState.color)}`], ownerState.disabled && styles.disabled],
  shouldForwardProp: prop => (0, _components.rootShouldForwardProp)(prop) || prop === 'classes'
})(({
  theme,
  ownerState
}) => ({
  textAlign: 'center',
  fontSize: theme.typography.body1.fontSize,
  lineHeight: 1.6,
  padding: '2px 5px 0',
  minHeight: 24,
  borderRadius: theme.shape.borderRadius,
  textTransform: 'uppercase',
  fontWeight: 'bold',
  color: theme.palette[ownerState.color].main,
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
    duration: theme.transitions.duration.short
  }),
  ...(ownerState.disableUppercase && {
    textTransform: 'none'
  }),
  '&:hover': {
    backgroundColor: (0, _mui.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
    color: theme.palette[ownerState.color].main,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  '&:active': {
    backgroundColor: (0, _mui.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity)
  },
  [`&.${_miniButtonClasses.default.disabled}`]: {
    color: theme.palette.action.disabled
  },
  [`&.${_miniButtonClasses.default.focusVisible}`]: {
    outline: `1px solid ${theme.palette.default.dark}`,
    outlineOffset: -1
  }
}));
const MiniButton = exports.MiniButton = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _mui.useThemeProps)({
    props: inProps,
    name: 'MiniButton'
  });
  const {
    children,
    className,
    color = 'default',
    disabled = false,
    disableFocusRipple = false,
    disableUppercase = false,
    type,
    ...other
  } = props;
  const ownerState = {
    ...props,
    color,
    disabled,
    disableFocusRipple,
    disableUppercase,
    type
  };
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MiniButtonRoot, {
    ref: ref,
    centerRipple: true,
    className: (0, _clsx.default)(classes.root, className),
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ownerState: ownerState,
    ...other,
    children: children
  });
});
var _default = exports.default = MiniButton;
